import { Badge } from "@chakra-ui/react";
import { useBootstrap } from "gen/endpoints/frontend/frontend";
import { startCase } from "lodash-es";
import { queryOptionsSingleShot } from "shared/utils/QueryUtils";

export const AppEnvironmentBadge: React.FC = () => {
  const { data } = useBootstrap({
    query: {
      ...queryOptionsSingleShot,
      throwOnError: false,
    },
  });

  if (!data?.environment || data.environment === "production") {
    return;
  }

  return (
    <Badge colorScheme="purple" ml="16px">
      {startCase(data.environment)}
    </Badge>
  );
};
